<h2 mat-dialog-title>Les données du patient</h2>
<mat-dialog-content>
    <mat-card class="validate-card">
        <mat-card-header>
            <mat-card-title><fa-icon [icon]="['fas','sticky-note']"></fa-icon>&nbsp;&nbsp;Note</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <app-patient-note [note]="data.content"></app-patient-note>
        </mat-card-content>
    </mat-card>
    <mat-card class="validate-card">
        <mat-card-header>
            <mat-card-title><fa-icon [icon]="['fas','calendar']"></fa-icon>&nbsp;&nbsp;Rendez-vous</mat-card-title>
        </mat-card-header>
        <mat-card-content style="max-height:250px;overflow:scroll;">
            <app-agenda-appointment-table [agenda]="agenda"></app-agenda-appointment-table>
        </mat-card-content>
    </mat-card>
    <app-patient-administrative [patient]="patient.patient" [displaymode]="displaymode"></app-patient-administrative>
    <app-patient-identity [patient]="patient.patient" [displaymode]="displaymode"></app-patient-identity>
    <app-patient-address [patient]="patient.patient" [displaymode]="displaymode"></app-patient-address>
    <app-patient-medical [patient]="patient.patient" [displaymode]="displaymode"></app-patient-medical>
    <app-patient-insurance [patient]="patient.patient" [displaymode]="displaymode"></app-patient-insurance>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-stroked-button (click)="close('ok')">Fermer</button>
</mat-dialog-actions>